/* Upgrade the native Liquid form using the existing, serialized cart controller. */
(() => {
  const page = document.querySelector('.moi-cart-page');
  if (!page || !window.iliaStorefront) return;
  window.iliaStorefront.request('cart.js', {cache: 'no-store'})
    .then(cart => window.iliaStorefront.renderCartContent(cart))
    .catch(() => {}); // The complete native update/checkout form remains usable.
})();
